module.exports = __webpack_public_path__ + "img/left-angle.ca8754fd.png";